export default __webpack_public_path__ + "static/media/deliveries_12.278118ef.png";